import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const LoadingItem = () => {
  return (
    <Box gap="s8">
      <Skeleton width="s96" height="s12" />
      <Skeleton width="s600" height="s32" />
    </Box>
  )
}

const LoadingBlock = ({ items }: { items: number }) => {
  return (
    <Box gap="s32">
      {Array.from({ length: items }).map((_, index) => (
        <LoadingItem key={index} />
      ))}
    </Box>
  )
}

const LoadingState = () => {
  return (
    <Box
      paddingTop="s40"
      style={{
        position: 'relative',
        gridColumnStart: '2',
        gridColumnEnd: 'span 10',
      }}
      paddingBottom="s48"
      gridColSpan={{ xxs: 10 }}
      gap="s40"
    >
      <Box gap="s32">
        <LoadingBlock items={5} />
      </Box>
    </Box>
  )
}

export default LoadingState
